var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',[_vm._l((_vm.block.innerBlocks),function(innerBlock,key){return [_c('HeaderCheckListItem',{key:`checkListBlock${key}`,attrs:{"content":_vm.getContent(innerBlock.innerHtml),"color":"#41a5dd","has-desktop-view":true}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }